import { render, staticRenderFns } from "./PecasForm.vue?vue&type=template&id=6cadf9c4&scoped=true&"
import script from "./PecasForm.vue?vue&type=script&lang=js&"
export * from "./PecasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cadf9c4",
  null
  
)

export default component.exports